import { Box } from '@mui/material';
import { useEffect, useMemo } from 'react';

interface PdfViewerProps {
  pdfView: File | null;
}

export function PdfViewer({ pdfView }: PdfViewerProps) {
  const url = useMemo(() => {
    return pdfView ? URL.createObjectURL(pdfView) : undefined;
  }, [pdfView]);

  useEffect(() => {
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [url]);

  if (!pdfView) return null; // Esto se ejecuta después de los hooks

  return (
    <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
      <embed src={url} type="application/pdf" width="100%" height="100%" />
    </Box>
  );
}
